import('./modules/newrelic').finally(() => import('./receiver'));
